import { ComponentPropsWithoutRef } from "react";

import { arrowDownShaftCss } from "./WordStudyOrganizer.styles";

const ArrowDown = (props: ComponentPropsWithoutRef<"div">) => (
  <div role="img" aria-hidden="true" {...props} css={arrowDownShaftCss} />
);

export default ArrowDown;
